export const showNotification = (msg) => ({
	type: 'NOTIFICATION',
	payload: { msg }
});
